import { wp, api } from '@/utils/client';

const state = {
	index: { meta: {total: 0, last_page:1, current_page:1}, data:[] },
	detail: { type: '' },
	resourceLoaded: false,
	activeTab: 0
}

const actions = {
	async fetchResources(context) {
		try {
			let response = await api.get('/resources');
			context.commit('fetchResources', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
	async fetchResource(context, data) {
		try {
			let response = await api.get('/resources/' + data.resSlug );
			context.commit('fetchResource', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	}
}

const mutations = {
	fetchResources(state, data) {
		state.index = data;
	},
	fetchResource(state, data) {
		state.detail = data;
		state.resourceLoaded = true;
	},
	changeActiveTab(state, tab) {
		state.activeTab = tab;
	}
}

export default {
	state,
	actions,
	mutations
}
